import React from 'react';
import { ISectionHeadingProps } from './types';
import styles from './SectionHeading.module.css';

export const SectionHeading: React.FC<ISectionHeadingProps> = ({
                                                                 className,
  children,
}) => <span className={`${styles.heading} ${className}`}>{children}</span>;
